import axios from "axios";
import { EMAIL_API_KEY, URLS } from "../constants";
import { SELECTED_SERVER_STORAGE_KEY } from "../config/server-options";

const getActiveBaseUrl = () =>
  localStorage.getItem(SELECTED_SERVER_STORAGE_KEY) || URLS.BASE_URL || "";

const axiosClient = axios.create({
  baseURL: getActiveBaseUrl(),
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
  },
});

const axiosEmailClient = axios.create({
  baseURL: URLS.EMAIL_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
    "api-key": EMAIL_API_KEY,
  },
});

export { axiosClient, axiosEmailClient };
